import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import {
  PathPickBasketDeleteRequestBody,
  PathPickNaverPartnerConnectRequestBody,
  PathPickSmartStoreInfoRequestBody,
} from "@/features/pathpick/features/basket/types/request-body";
import { PathPickSmartStoreInfoResponse } from "@/features/pathpick/features/basket/types/response";

const url = {
  deletePathPickBasket: (companyId: number) =>
    `/buyers/${companyId}/pathpick/basket`,
  clearPathPickBasket: (companyId: number) =>
    `/buyers/${companyId}/pathpick/basket/all`,
  smartStoreInfos: (companyId: number) =>
    `/buyers/${companyId}/smart-store-infos`,
  connectNaverPartner: (companyId: number) =>
    `/pathpick/naver_partner/buyers/${companyId}/connect`,
  disconnectNaverPartner: (companyId: number) =>
    `/pathpick/naver_partner/buyers/${companyId}/disconnect`,
};

export const pathPickBasketMutationApi = {
  deletePathPickBasket: async (
    companyId: number,
    body: PathPickBasketDeleteRequestBody
  ) =>
    await axiosClient.delete(url.deletePathPickBasket(companyId), {
      data: toSnakeKeyObject(body),
    }),
  clearPathPickBasket: async (companyId: number) =>
    await axiosClient.delete(url.clearPathPickBasket(companyId)),
  // 스마트스토어 상품 등록 기본 정보 생성/수정/삭제
  // 생성/수정은 저장된 정보를 응답으로 돌려준다 — 신청 플로우가 재조회 없이 관문을 다시 판정하는 데 쓴다.
  createSmartStoreInfo: async (
    companyId: number,
    body: PathPickSmartStoreInfoRequestBody
  ) => {
    const { data } = await axiosClient.post<PathPickSmartStoreInfoResponse>(
      url.smartStoreInfos(companyId),
      toSnakeKeyObject(body)
    );
    return data;
  },
  updateSmartStoreInfo: async (
    companyId: number,
    body: PathPickSmartStoreInfoRequestBody
  ) => {
    const { data } = await axiosClient.put<PathPickSmartStoreInfoResponse>(
      url.smartStoreInfos(companyId),
      toSnakeKeyObject(body)
    );
    return data;
  },
  deleteSmartStoreInfo: async (companyId: number) =>
    await axiosClient.delete(url.smartStoreInfos(companyId)),
  // 네이버 제휴 연결/해제 — 판매자ID를 직접 입력해 연결하고, 해제는 바디 없이 호출한다.
  // 성공 응답 스키마가 비어 있어 반환값은 쓰지 않는다.
  connectNaverPartner: async (
    companyId: number,
    body: PathPickNaverPartnerConnectRequestBody
  ) =>
    await axiosClient.post(
      url.connectNaverPartner(companyId),
      toSnakeKeyObject(body)
    ),
  disconnectNaverPartner: async (companyId: number) =>
    await axiosClient.post(url.disconnectNaverPartner(companyId)),
};
